import {
  IMPORTAR_LOTE_TICK_MS,
  REPLICAR_TICK_MS,
  RODAR_LOTE_TICK_MS,
} from '@modules/controladoria-v2/constants/Status'
import { wait } from '@modules/controladoria-v2/utils/wait'

// ---------- Fechamentos ----------

export const setFechamentos = ({ commit }, payload) => {
  commit('SET_FECHAMENTOS', payload)
}

export const addFechamento = ({ commit }, payload) => {
  if (!payload) return
  commit('ADD_FECHAMENTO', payload)
}

export const setFechamentoAtual = ({ commit }, payload) => {
  commit('SET_FECHAMENTO_ATUAL', payload)
  // configDRE não é mais hidratado de localStorage — a API real é a fonte da verdade
  // e cada aba dispara `apiControladoriaConfigDRE.carregar` ao montar (ver decisão #5
  // do plano cat_lanc).
}

export const fecharVersao = ({ commit }, payload) => {
  commit('INCREMENT_VERSOES_PUBLICADAS')
  if (payload && payload.data_referencia) {
    commit('ADD_FECHAMENTO', {
      data_referencia: payload.data_referencia,
      versaoFechada: true,
      nota: payload.nota || '',
    })
  }
}

// ---------- Importação ----------

// Replace o mapa inteiro de importacoes (qtd_registros/valor_total por tipo)
// vindo dos sumários do backend, junto com a data_referencia que os gerou.
export const setImportacoes = ({ commit }, payload) => {
  commit('SET_IMPORTACOES', payload)
}

export const setImportacaoStatus = ({ commit }, payload) => {
  commit('SET_IMPORTACAO_STATUS', payload)
}

// Substitui o mapa inteiro `{ tipo: {...} }` do status de processamento no
// dataroom vindo do endpoint de status (polling). Action só comita — o fetch
// vive na camada de API.
export const setDataroomStatus = ({ commit }, payload) => {
  commit('SET_DATAROOM_STATUS', payload)
}

// ---------- ConfigDRE ----------

// O backend é a fonte da verdade para configDRE. `setConfigGrid` apenas atualiza
// o cache em memória (consumido pela view enquanto a tela está aberta) sem
// efeitos colaterais em localStorage. `resetConfigGrid` apaga a chave para que a
// próxima `apiControladoriaConfigDRE.carregar` populate do zero.

export const setConfigGrid = ({ commit }, payload) => {
  if (!payload || !payload.tabKey) return
  commit('SET_CONFIG_GRID', payload)
}

export const resetConfigGrid = ({ commit }, payload) => {
  if (!payload || !payload.tabKey) return
  commit('RESET_CONFIG_GRID', payload)
}

// ---------- ConfigDRE dropdown options ----------

export const setConfigDREDropdownOptions = ({ commit }, payload) => {
  commit('SET_CONFIG_DRE_DROPDOWN_OPTIONS', payload)
}

// ---------- Listas ----------

export const setListas = ({ commit }, payload) => {
  commit('SET_LISTAS', payload)
}

export const setListasLoading = ({ commit }, payload) => {
  commit('SET_LISTAS_LOADING', payload)
}

// ---------- Engines ----------

export const setEngineStatus = ({ commit }, payload) => {
  commit('SET_ENGINE_STATUS', payload)
}

// Replaces the entire engineStatus map at once. Used by the API layer after a
// fresh load from the backend so we never carry over stale per-engine fields
// (errors/warnings/data_execucao) from a previous month. Payload:
// `{ value, dataReferencia }` — a data_referencia carimba a que mês o mapa
// pertence (ver getter `engineStatusReady`).
export const replaceEngineStatus = ({ commit }, payload) => {
  commit('REPLACE_ENGINE_STATUS', payload)
}

export const setEngineStatusLoading = ({ commit }, payload) => {
  commit('SET_ENGINE_STATUS_LOADING', payload)
}

export const setEngineStatusError = ({ commit }, payload) => {
  commit('SET_ENGINE_STATUS_ERROR', payload)
}

// `runEngine` / `runAllEngines` actions were removed in favor of direct POSTs in
// `apiControladoriaMotor`. The optimistic mutation to `engineStatus` happens via
// `setEngineStatus`; the real status is reloaded via `replaceEngineStatus` after
// each polled `GET /fechamentos/motor`.

// ---------- Parâmetros de impostos ----------

// Hidrata o slice `taxParams` a partir do `parametros_impostos` devolvido pelo
// status do motor, para pré-selecionar os checkboxes do modal de rodagem.
export const setTaxParams = ({ commit }, payload) => {
  commit('SET_TAX_PARAMS', payload)
}

// ---------- Lote jobs ----------

// Lote modals show a `v-progress-linear indeterminate` while the (mocked) backend
// runs. We wait a duration proportional to the workload so the modal stays in its
// "processando" phase long enough for the user to perceive the transition, then
// resolve to flip the modal to "sucesso". No store state is mutated — the real
// work happens behind real APIs once those land.
const simulateLoteWait = async (totalSteps, tickMs) => {
  const total = Math.max(1, totalSteps)
  await wait(total * tickMs)
}

export const replicarConfig = async (_ctx, payload = {}) => {
  const destinos = Array.isArray(payload.datasReferenciaDestino)
    ? payload.datasReferenciaDestino
    : []
  await simulateLoteWait(destinos.length, REPLICAR_TICK_MS)
  return { totalDestinos: destinos.length }
}

export const rodarMesesLote = async (_ctx, payload = {}) => {
  const datas = Array.isArray(payload.datasReferencia)
    ? payload.datasReferencia
    : []
  const motores = Array.isArray(payload.motores) ? payload.motores : []
  const totalSteps = datas.length * motores.length
  await simulateLoteWait(totalSteps, RODAR_LOTE_TICK_MS)
  return { totalMeses: datas.length, totalMotores: motores.length }
}

export const importarLote = async (_ctx, payload = {}) => {
  const datas = Array.isArray(payload.datasReferencia)
    ? payload.datasReferencia
    : []
  await simulateLoteWait(datas.length, IMPORTAR_LOTE_TICK_MS)
  return { totalMeses: datas.length }
}

// ---------- Reset ----------

export const resetState = ({ commit }) => {
  commit('RESET_STATE')
}
